import * as React from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Form, Button, Icon, Spin } from "antd";
import { ImageFile } from "react-dropzone";
import * as Recaptcha from "react-recaptcha";
import { FormikProps, Field, withFormik, Form as FForm } from "formik";
import AvatarEditor from "react-avatar-editor";

import { ROUTE_NAMES, userValidationSchema } from "@bakbak/common";
import {
  RegisterMutation_register,
  RegisterMutation_register_user,
  RegisterMutationVariables,
  S3SignMutationVariables,
  S3SignMutation_signS3
} from "@bakbak/controller";

import { InputField } from "../../../util/InputField";
import { DropzoneField } from "../../../util/DropzoneField";
import { THEME_COLOR } from "../../../constants";
import { base64StringtoFile } from "../../../util/ImageCrop";

const FormItem = Form.Item;

interface FormValues {
  email: string;
  userName: string;
  password: string;
  picture: ImageFile | null;
}
interface Props {
  submit: (
    values: RegisterMutationVariables
  ) => Promise<RegisterMutation_register | null>;
  gotoLogin: () => void;
  onCancel: () => void;
  onComplete: (user: RegisterMutation_register_user | null) => void;
  signS3Mutate: (
    variables: S3SignMutationVariables
  ) => Promise<S3SignMutation_signS3 | null>;
}

interface State {
  secureText: boolean;
  showAlert: boolean;
  recaptchaSuccess: boolean;
}

let avatarEditorRef: any;
export class RegisterForm extends React.PureComponent<
  FormikProps<FormValues> & Props,
  State
> {
  state = { secureText: true, showAlert: false, recaptchaSuccess: false };
  constructor(props: any) {
    super(props);
    avatarEditorRef = React.createRef();
  }
  toggleSecureText = () => {
    this.setState(state => ({ secureText: !state.secureText }));
  };
  submit = () => {
    this.setState(() => ({ showAlert: true }));
    this.props.handleSubmit();
  };
  showSubmitAlert = () => (
    <Spin tip="Uploading Image. Please wait...." size={"large"} />
  );
  verifyRecaptcha = (response: any) => {
    this.setState(() => ({ recaptchaSuccess: true }));
  };
  componentDidUpdate() {
    if (this.props.errors) {
      this.setState(() => ({ showAlert: false }));
    }
  }

  renderImage = (picture: any) => (
    <AvatarEditor
      ref={ref => (avatarEditorRef = ref)}
      image={picture}
      width={80}
      height={80}
      border={[50, 50]}
      color={[255, 255, 255, 0.6]} // RGBA
      rotate={0}
    />
  );

  render() {
    const { values } = this.props;
    // if(errors){
    //   this.setState(() => ({ showAlert: false }));
    // }
    return (
      <FForm style={{ display: "flex", marginTop: 20 }}>
        <div style={{ width: 500, margin: "auto" }}>
          <div
            style={{
              fontSize: 32,
              fontWeight: 600,
              marginBottom: 20,
              color: THEME_COLOR
            }}
          >
            Register
          </div>
          <Field
            name="email"
            label={
              <span>
                Email*
                <span style={{ marginLeft: 10, fontSize: 10, color: "grey" }}>
                  (*unique)
                </span>
              </span>
            }
            prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="email"
            component={InputField}
          />
          <Field
            name="userName"
            label={
              <span>
                User Name*
                <span style={{ marginLeft: 10, fontSize: 10, color: "grey" }}>
                  (*unique)
                </span>
              </span>
            }
            prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="user name"
            component={InputField}
          />
          <Field
            name="password"
            label="Password* "
            prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
            placeholder="password"
            type="password"
            component={InputField}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 30,
              justifyContent: "space-between"
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between"
              }}
            >
              <div>Select photo:</div>
              {values.picture && this.renderImage(values.picture)}
            </div>
            <Field name="picture" component={DropzoneField} />
          </div>

          <div style={{ marginTop: 20 }}>
            <Recaptcha
              sitekey="6Lc7DIYUAAAAAI2HOLsOgT7QUa8LUI87zqgU2-8Z"
              verifyCallback={this.verifyRecaptcha}
            />
          </div>

          <FormItem>
            <Link to={ROUTE_NAMES.FORGOT_PASSWORD}>Forgot password</Link>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
              }}
            >
              <Button
                disabled={!this.state.recaptchaSuccess}
                onClick={this.submit}
                style={{
                  width: "40%",
                  backgroundColor: THEME_COLOR,
                  color: "white",
                  borderColor: THEME_COLOR
                }}
              >
                Register
              </Button>
              <Button
                onClick={this.props.onCancel}
                style={{
                  width: "40%",
                  backgroundColor: "Grey",
                  color: "white",
                  borderColor: "grey"
                }}
              >
                Cancel
              </Button>
            </div>
            {this.state.showAlert && this.showSubmitAlert()}
            Or Existing Users <Link to={ROUTE_NAMES.LOGIN}>Login now!</Link>
          </FormItem>
        </div>
      </FForm>
    );
  }
}

export const RegisterView = withFormik<Props, FormValues>({
  validationSchema: userValidationSchema,
  mapPropsToValues: () => ({
    email: "",
    userName: "",
    password: "",
    picture: null
  }),
  handleSubmit: async (values, { props, setErrors }) => {
    let responseImage;
    let picture;
    if (values.picture) {
      if (avatarEditorRef) {
        const canvasScaled = avatarEditorRef.getImageScaledToCanvas();
        const dataURL = canvasScaled.toDataURL();
        const file = base64StringtoFile(
          dataURL,
          values.userName + values.picture.name
        );

        const formData = new FormData();
        formData.append("file", file);
        formData.append("upload_preset", "default-preset");
        responseImage = await axios.post(
          `https://api.cloudinary.com/v1_1/bakbak24/image/upload`,
          formData
        );
        picture = responseImage.data.secure_url;
      }
    }
    const response = await props.submit({ ...values, picture });
    if (response && response.errors) {
      setErrors(response.errors as any);
    } else if (response) {
      props.onComplete(response.user);
    }
  }
})(RegisterForm);



// WEBPACK FOOTER //
// ./src/modules/auth/register/RegisterView.tsx